// "Start your Korean learning journey" — centered title + subtitle + two CTA buttons.
import { useEffect, useState } from "react";
import { i18n, initializeI18n } from "../localization/i18n";
import { translate } from "../localization/translateService";

export default function JourneyCtaSection({ props }) {
  const [lang, setLang] = useState(null);
  const [t, setT] = useState({});

  // Init i18n + track current language (re-translate on language change)
  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => setLang(i18n.language));
    } else {
      setLang(i18n.language);
    }
  }, []);

  // i18n defaults — used only when the CMS field is empty (no hardcoded English in markup)
  useEffect(() => {
    let active = true;
    (async () => {
      const out = {};
      out.title = await translate("UMBRACO_LANDING.HOME.CTA.TITLE", false, "Start your Korean learning journey");
      out.subtitle = await translate("UMBRACO_LANDING.HOME.CTA.SUBTITLE", false, "Tell us your goal. We'll recommend suitable lessons.");
      out.primaryLabel = await translate("UMBRACO_LANDING.HOME.CTA.PRIMARY_BTN", false, "Enroll Now");
      out.secondaryLabel = await translate("UMBRACO_LANDING.HOME.CTA.SECONDARY_BTN", false, "Explore First");
      if (active) setT(out);
    })();
    return () => { active = false; };
  }, [lang]);

  // CMS first (Umbraco variant); i18n default when CMS empty
  const title = t.title || props?.journeyTitle || "";
  const subtitle = t.subtitle || props?.journeySubtitle || "";
  const primaryLabel = t.primaryLabel || props?.journeyPrimaryLabel || "";
  const primaryLink = props?.journeyPrimaryLink || "/pretest";
  const secondaryLabel = t.secondaryLabel || props?.journeySecondaryLabel || "";
  const secondaryLink = props?.journeySecondaryLink || "/real-time-lectures?tab=allTutors&page=1&rows=5";

  return (
    <section className="journey-cta">
      <div className="journey-cta__inner">
        <h2 className="journey-cta__title animate-on-scroll">{title}</h2>
        {subtitle && <p className="journey-cta__subtitle animate-on-scroll">{subtitle}</p>}
        <div className="journey-cta__actions animate-on-scroll">
          {primaryLabel && (
            <a className="journey-cta__btn journey-cta__btn--primary" href={primaryLink}>{primaryLabel}</a>
          )}
          {secondaryLabel && (
            <a className="journey-cta__btn journey-cta__btn--ghost" href={secondaryLink}>{secondaryLabel}</a>
          )}
        </div>
        <span className="journey-cta__deco" aria-hidden="true">
          <svg viewBox="0 0 372 325" width="100%" height="100%" fill="none" preserveAspectRatio="xMidYMid meet">
            <mask id="journeyCtaMask" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="372" height="372">
              <circle cx="186" cy="186" r="168" fill="#FFD335" stroke="#FFD335" strokeWidth="36" />
            </mask>
            <g mask="url(#journeyCtaMask)">
              <path d="M107.102 184.038C105.281 178.023 103.631 171.726 102.175 165.15C103.644 170.715 105.352 177.065 107.102 184.038Z" fill="#FFD335" />
              <path d="M185.583 86.7461C217.278 122.473 261.067 212.275 237.296 256.482C209.416 308.329 127.198 278.168 102.175 165.15C117.328 222.562 158 363.5 6.5 411" stroke="#FFD335" strokeWidth="36" />
              <path d="M168.482 168.49L168.482 75.0625H259.303" stroke="#FFD335" strokeWidth="36" />
            </g>
          </svg>
        </span>
      </div>
    </section>
  );
}
